import $ from "jquery";
import settings from "settings";

var loaded = {};
export var requireCSS = function (css) {
  // From requirejs documentation.
  if (loaded[css]) return;

  var link = document.createElement("link");
  link.type = "text/css";
  link.rel = "stylesheet";
  link.href = settings.STATIC_URL + "css/" + css + ".css";
  document.getElementsByTagName("body")[0].appendChild(link);
  loaded[css] = true;
};

export var array_equals = function (a, b) {
  if (a.length != b.length) return false;
  for (var i in a) {
    if (a[i] != b[i]) return false;
  }
  return true;
};

export var date_to_string = function (date) {
  function pad(number) {
    if (number < 10) {
      return "0" + number;
    }
    return number;
  }
  if (date.getUTCHours() == 0 && date.getUTCMinutes() == 0) {
    return (
      date.getUTCFullYear() +
      "-" +
      pad(date.getUTCMonth() + 1) +
      "-" +
      pad(date.getUTCDate())
    );
  } else {
    return (
      date.getUTCFullYear() +
      "-" +
      pad(date.getUTCMonth() + 1) +
      "-" +
      pad(date.getUTCDate()) +
      " " +
      pad(date.getUTCHours()) +
      ":" +
      pad(date.getUTCMinutes())
    );
  }
};

export var fullscreen = function (_on, $el) {
  console.log("fullscreen", _on, $el);
  if (_on) {
    var element = $($el)[0];
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    }
  } else {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    }
  }
};

// Makes a str a htm safe text
export var html_escape = function (txt) {
  return txt.replace("&", "&amp;").replace("<", "&lt;").replace(">", "&gt;");
};

export default {
  requireCSS: requireCSS,
  array_equals: array_equals,
  date_to_string: date_to_string,
  fullscreen: fullscreen,
  html_escape: html_escape,
};
